import { render, staticRenderFns } from "./TeamInfo.vue?vue&type=template&id=45228a98&scoped=true"
import script from "./TeamInfo.vue?vue&type=script&lang=js"
export * from "./TeamInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamInfo.vue?vue&type=style&index=0&id=45228a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45228a98",
  null
  
)

export default component.exports